<script>
    let className = '';
    export { className as class };
</script>

<img src="/logo.svg" alt="Critikid Logo" class="h-auto aspect-[10/4] {className} object-contain" />
